module.exports = __webpack_public_path__ + "static/media/fly.c98bff23.svg";